import React from 'react';

const Footer = () => {
  return (
    <footer style={{ background: '#0f172a', color: 'white', padding: '40px 20px', marginTop: '50px', textAlign: 'center' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', maxWidth: '1000px', margin: '0 auto' }}>
        
        {/* معلومات عن المنصة */}
        <div>
          <h3 style={{ color: '#fbbf24' }}>CPE Tech</h3>
          <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#ccc' }}>
            المنصة الأولى في المنطقة لصيانة الأجهزة الإلكترونية وبيع الملحقات الأصلية.
            خدمة سريعة، ضمان حقيقي، واحترافية في العمل.
          </p>
        </div>

        {/* العنوان */}
        <div>
          <h3 style={{ color: '#fbbf24' }}>📍 موقعنا</h3>
          <p>الجزائر، ولاية بسكرة</p>
          <p>دائرة أورلال</p>
          <a href="https://maps.google.com" target="_blank" rel="noreferrer" style={{ color: '#38bdf8', textDecoration: 'none' }}>
            عرض على الخريطة 🗺️
          </a>
        </div>

        {/* الاتصال */}
        <div>
          <h3 style={{ color: '#fbbf24' }}>📞 تواصل معنا</h3>
          <p>هاتف: <a href="tel:0770281922" style={{color: 'white', textDecoration: 'none'}}>0770281922</a></p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '10px' }}>
            <a href="https://wa.me/213770281922" style={{ background: '#25D366', color: 'white', padding: '5px 10px', borderRadius: '5px', textDecoration: 'none' }}>WhatsApp</a>
            <a href="https://t.me/213770281922" style={{ background: '#0088cc', color: 'white', padding: '5px 10px', borderRadius: '5px', textDecoration: 'none' }}>Telegram</a>
          </div>
          <p style={{ fontSize: '12px', marginTop: '10px' }}>www.fofotechno.com</p>
        </div>

      </div>
      <div style={{ borderTop: '1px solid #333', marginTop: '20px', paddingTop: '20px', fontSize: '12px', color: '#777' }}>
        © 2024 CPE Tech. جميع الحقوق محفوظة.
      </div>
    </footer>
  );
};

export default Footer;